import {Component} from 'react';

import SecondServer from '../database/SecondServer'
import {siteAccessCode } from '../database/apiv2SiteAccessor';
import {promiseHistoricalSiteData} from '../Report/DataHelpers'
import {filterSensors, filterConnected, filterAdvancing, filterRepeaters} from './filters';
import {between, apiFormat, sanitizeDateTime} from '../timeFunctions/timeFns'
import { urlNonAdvancing } from '../database/apiUrls';
import { filterRPMT } from '../Report/Model/DeviceType';
import { getIcons } from "../Report/Controls/DeviceIcons";

export default class DeviceHealthData extends Component {
  constructor(props) {
    super(props);
    this.ss = new SecondServer(props);
  }

  componentWillUnmount() {
    if (this.ss)
      this.ss.cancel();
  }

  async getHealth(paramStart, paramEnd) {
    const readings = this.mergeTimes(await this.fetchTwoTimes (paramStart, paramEnd))
    if (readings && readings.length) {
      const sensors = filterSensors(readings);
      const connected = filterConnected(sensors);
      const advancing = filterAdvancing(sensors);
      return {connected: connected.length, advancing: advancing.length, notAvailable: false, 
            connData: connected, advData:advancing}
    }
    else 
      return {connected: null, advancing: null, notAvailable: true}
  }
  
  async getHealthofThese(paramStart, paramEnd, deviceArr, name='RadioID-Hex') {
    const readings = this.mergeTimes(await this.fetchTwoTimes (paramStart, paramEnd))
    if (readings && readings.length) {
      const sensorReads = filterSensors(readings);
      const deviceIds = deviceArr.map(item => item[name].toUpperCase())
      const onlyReadings = sensorReads.filter(item => deviceIds.includes(item.DeviceId.toUpperCase()))
      const connected = filterConnected(onlyReadings);
      const advancing = filterAdvancing(onlyReadings);
      const rptrReadings = filterRepeaters(readings)
      const rptrs = filterConnected(rptrReadings)
      let connRpmt = 0
      const rpmt = filterRPMT(deviceArr)
      if (rpmt.length > 0) {
        const siteId = siteAccessCode(this.props.getActiveSite())
        const icons = await getIcons ({...this.props, ss: this.ss, ac: siteId})
        const rpmtIcons = icons.data.icons.filter(i => 
          i?.icon === 'GRN_CHK' && i?.node_type === 'RPMT')
        connRpmt = rpmtIcons.length
      }
      return {connected: connected.length, advancing: advancing.length, notAvailable: false, 
        connData: connected, advData:advancing, rptrCount: rptrs.length+connRpmt}
    }
    else 
      return {connected: null, advancing: null, notAvailable: true}
  }
  async getHealthFromThese (start, end, devices) {
    if (!devices)
      return {connected: null, advancing: null, notAvailable: true}
    const rptr = devices.filter(d=>d.type === 'RPTR')
    const connected = devices.filter(d => between(sanitizeDateTime(d?.LatestData?.RXTime, {zone:'UTC'}), start, end))
    const connIds = connected.map(c=>c.device_id)
    const connMDT = connIds.filter(id => !id.toUpperCase().startsWith('E'))
    const site = this.props.getActiveSite();
    const url = urlNonAdvancing(siteAccessCode(site), apiFormat(start), apiFormat(end))
    const resp = await this.ss.apiData (url);
    const advData = resp?.data?.data?.non_incrementing ?? []
    return {connected: connMDT.length, advancing: advData.length, 
      notAvailable: false, connData: connIds, advData:advData, rptrCount: rptr.length}
  }
 
 async promiseRange (from, until, type) {
    const siteId = siteAccessCode(this.props.getActiveSite())
    return promiseHistoricalSiteData(siteId, from, until, this.ss, type);
  }
  async promisePointInTime(when, boundary=1, type='SensorData') {
    const siteId = siteAccessCode(this.props.getActiveSite())
    let range = new Date(when.getTime() + boundary * 6 * 3600 * 1000);
    if (boundary > 0) [when, range] = [range, when];
    return promiseHistoricalSiteData(siteId, range, when, this.ss, type);
  }

  async fetchTwoTimes(first, second, type='SensorData') {
    const promise1 = this.promisePointInTime (first, 1, type);
    const promise2 = this.promisePointInTime (second, -1, type);
    return [await promise1, await promise2]
  }

  mergeTimes (arrHistory) {
    const first = arrHistory[0]?.jsonResponse?.data?.data?.raw_data ?? [];
    const last = arrHistory[1]?.jsonResponse?.data?.data?.raw_data ?? [];
    return first.concat(last)
  }

  render() {
    return null;
  }
}
